export default __webpack_public_path__ + "static/media/start-end.a806c584.svg";